export function getDeviceId() {
  let deviceId = localStorage.getItem("contalearn_device_id");

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("contalearn_device_id", deviceId);
  }

  return deviceId;
}

export function getDeviceInfo() {
  const ua = navigator.userAgent;

  // Sistem de operare
  let operatingSystem = "unknown";

  if (/iPhone|iPad|iPod/i.test(ua)) {
    operatingSystem = "ios";
  } else if (/Android/i.test(ua)) {
    operatingSystem = "android";
  } else if (/Windows/i.test(ua)) {
    operatingSystem = "windows";
  } else if (/Macintosh|Mac OS X/i.test(ua)) {
    operatingSystem = "macos";
  } else if (/Linux/i.test(ua)) {
    operatingSystem = "linux";
  }

  // Tip dispozitiv
  let deviceType = "desktop";

  if (/iPad|Tablet/i.test(ua)) {
    deviceType = "tablet";
  } else if (/Mobi|Android|iPhone|iPod/i.test(ua)) {
    deviceType = "mobile";
  }

  // Browser
  let browser = "unknown";

  if (/Edg/i.test(ua)) {
    browser = "edge";
  } else if (/CriOS/i.test(ua)) {
    browser = "chrome-ios";
  } else if (/FxiOS/i.test(ua)) {
    browser = "firefox-ios";
  } else if (/Chrome/i.test(ua)) {
    browser = "chrome";
  } else if (/Safari/i.test(ua)) {
    browser = "safari";
  } else if (/Firefox/i.test(ua)) {
    browser = "firefox";
  }

  // Verificăm dacă rulează ca PWA
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  return {
    deviceId: getDeviceId(),
    deviceType,
    operatingSystem,
    browser,
    isStandalone,
  };
}